import { Text } from '@lmc/design-system'
import { cssVars } from '@lmc/design-system/tokens'
import { NAMESPACE } from 'locale'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import {
  FACTOR_KEYS,
  GROUP_KEYS
} from '../../../steps/investigation/ContributingFactors'
import { List } from '../../readLayout'
import type { TickedFactorGroup } from '../../readRules'

const { spacing } = cssVars

type ContributingFactorsValueProps = {
  groups: ReadonlyArray<TickedFactorGroup>
  testId: string
}

/** The ticked factors under their group's name. */
const ContributingFactorsValue = ({
  groups,
  testId
}: ContributingFactorsValueProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  return (
    <Groups>
      {groups.map(({ group, ticked }) => (
        <div key={group} data-testid={`${testId}-${group}`}>
          <Text weight="semibold">{t(GROUP_KEYS[group])}</Text>
          <List>
            {ticked.map((factor) => (
              <li key={factor}>{t(FACTOR_KEYS[factor])}</li>
            ))}
          </List>
        </div>
      ))}
    </Groups>
  )
}

const Groups = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[100]};
`

export default ContributingFactorsValue
